module.exports = {
	"id": "CZ",
	"name": "Czech Republic",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.026208,
			"12": 0.017472,
			"13": null,
			"14": null,
			"15": 0.008736,
			"16": null,
			"17": null,
			"18": 0.017472,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.061152,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.026208,
			"27": null,
			"28": null,
			"29": 0.270816,
			"30": null,
			"31": 0.034944,
			"32": null,
			"33": 0.008736,
			"34": 0.034944,
			"35": 0.017472,
			"36": 0.017472,
			"37": 0.034944,
			"38": 0.026208,
			"39": 0.078624,
			"40": 0.017472,
			"41": 0.034944,
			"42": 0.026208,
			"43": 0.969696,
			"44": 0.04368,
			"45": 0.04368,
			"46": 0.034944,
			"47": 0.061152,
			"48": 0.17472,
			"49": 2.542176,
			"50": 0.899808,
			"51": 2.847936,
			"52": 2.245152,
			"53": 26.941824,
			"54": 6.761664,
			"55": 0.052416,
			"56": 0.026208,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.026208,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.017472,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.008736,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.008736,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.096096,
			"25": null,
			"26": 0.017472,
			"27": null,
			"28": 0.017472,
			"29": null,
			"30": 0.008736,
			"31": 0.026208,
			"32": 0.008736,
			"33": 0.017472,
			"34": 0.008736,
			"35": 0.017472,
			"36": 0.017472,
			"37": 0.017472,
			"38": 0.157248,
			"39": 0.04368,
			"40": 0.026208,
			"41": 0.04368,
			"42": 0.04368,
			"43": 0.733824,
			"44": 0.096096,
			"45": 0.532896,
			"46": 0.288288,
			"47": 2.245152,
			"48": 1.930656,
			"49": 13.243776,
			"50": 0.401856,
			"51": 0.008736,
			"52": null,
			"3.5": 0.017472,
			"3.6": 0.04368
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.017472,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.008736,
			"36": 0.13104,
			"37": 0.052416,
			"38": 0.48048,
			"39": 0.489216,
			"40": 2.75184,
			"41": 0.26208,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.017472,
			"12.1": 0.323232
		},
		"safari": {
			"0": null,
			"4": 0.026208,
			"5": 0.017472,
			"6": null,
			"7": 0.008736,
			"8": 0.078624,
			"9": 0.096096,
			"10": 1.039584,
			"3.1": null,
			"3.2": null,
			"5.1": 0.026208,
			"6.1": 0.017472,
			"7.1": 0.008736,
			"9.1": 0.585312
		},
		"ios_saf": {
			"8": 0,
			"10": 1.53112603497,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0412620749376,
			"8.1-8.4": 0.0762299350541,
			"9.0-9.2": 0.0363665745212,
			"9.3": 0.554823380516
		},
		"android": {
			"3": 0,
			"4": 0.0203023875969,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00253779844961,
			"4.1": 0.0732336124031,
			"4.2-4.3": 0.183084031008,
			"4.4": 0.419824372093,
			"4.4.3-4.4.4": 0.42344979845
		},
		"ie": {
			"6": null,
			"7": 0.00912034244946,
			"8": 0.601942601665,
			"9": 0.246249246136,
			"10": 0.282730615933,
			"11": 6.53016519382,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0264121414234,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000733670595094
		},
		"edge": {
			"12": 0.122304,
			"13": 0.847392,
			"14": 1.930656
		},
		"ie_mob": {
			"10": 0.0730271549296,
			"11": 0.29732484507
		},
		"bb": {
			"7": 0.011692,
			"10": null
		},
		"samsung": {
			"0": 0.899968
		},
		"and_uc": {
			"0": 0.091008
		},
		"op_mini": {
			"0": 0.355846187982
		},
		"and_chr": {
			"0": 7.973904
		},
		"and_ff": {
			"0": 0.016432
		}
	},
	"total": 94.694092
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CZ.json
 ** module id = 505
 ** module chunks = 0
 **/